export default "__VITE_ASSET__d0aad126__"